__turbopack_context__.v({
  "actions": "uTTNBq_actions",
  "container": "uTTNBq_container",
  "phoneRow": "uTTNBq_phoneRow",
  "secondaryText": "uTTNBq_secondaryText",
  "visitingHourDateTime": "uTTNBq_visitingHourDateTime",
  "visitingHoursContainer": "uTTNBq_visitingHoursContainer",
});
